<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="8" :lg="8" :md="8" :sm="24">
            <a-form-item :label="language['gift_product_code']">
              <a-input :placeholder="language['common.pleaseInput']+language['gift_product_code']" v-model="queryParam.productCode"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="8" :lg="8" :md="8" :sm="24">
            <a-form-item :label="language['gift_product_name']">
              <a-input :placeholder="language['common.pleaseInput']+language['gift_product_name']" v-model="queryParam.productName"></a-input>
            </a-form-item>
          </a-col>
<!--          <a-col :xl="8" :lg="8" :md="8" :sm="24">
            <a-form-item :label="language['gift_product_vendor']">
              <a-select  :placeholder="language['common.pleaseInput']+language['gift_product_vendor']" @change='changeSupplierCode' v-model='supplierCode'>
                <a-select-option v-for="(value, key) in vendorOptions" :key="key" :value="value">
                  {{ value }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="8" :lg="8" :md="8" :sm="24">

            <a-form-item :label="language['gift_user_app']">
              <a-select  :placeholder="language['common.pleaseInput']+language['gift_user_app']" @change='changeAppCode' v-model='appCode' >
                <a-select-option v-for="(value, key) in appOptions" :key="key" :value="value">
                  {{ value }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>-->

          <a-col :xl="6"
                 :lg="7"
                 :md="8"
                 :sm="24">
            <a-form-model-item :label="language['gift_user_app']"
                               :labelCol="labelCol">
              <a-select v-model="queryParam.appCode"
                        :placeholder="language['common.pleaseChoose'] + language['gift_user_app']"
                        @change="handlerApp" :disabled='appLimit.flag'>
                <a-select-option v-for="(value, key) in appOptions" :key="key" :value="key">
                  {{ value }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :xl="6"
                 :lg="7"
                 :md="8"
                 :sm="24"
                 v-has="'produc:supplier'">
            <a-form-item :label="language['gift_product_vendor']">
              <a-select v-model="queryParam.supplierCode"  @change="updateSupplier"
                        :placeholder="language['common.pleaseChoose'] + language['gift_product_vendor']">
                <a-select-option v-for='(v,k) in vendorMap' :key='k' :value='k' :label='v'>
                  {{v}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>


          <a-col :xl="8" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
<!--      <a-button @click="handleAdd" type="primary" icon="plus" v-has="'gift:stock:add'">{{language['common.insertButton']}}</a-button>-->
      <a-button type="primary" icon="download" @click="handleExportXls('product_stock')" v-has="'gift:stock:export'">{{language['common.exportButton']}}</a-button>
      <a-button type="primary" icon="download" v-has="'gift:stock:import'" @click="downloadTemplate()">{{language['common.import.template.download']}}</a-button>

      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import" v-has="'gift:stock:import'" >{{language['common.importButton']}}</a-button>
      </a-upload>
<!--      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>-->
<!--      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay"  v-has="'gift:stock:delete'" >
          <a-menu-item key="1" @click="batchDel" v-has="'gift:stock:delete'" ><a-icon type="delete"  />{{language['common.delete']}}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{language['common.batchAction']}} <a-icon type="down" /></a-button>
      </a-dropdown>-->
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{language['common.choosed']}} <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{language['common.item']}}
        <a style="margin-left: 24px" @click="onClearSelected">{{language['common.clear']}}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="false"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <template slot='app' slot-scope='text'>
          <div class='slot-content' :title='appOptions[text]' >
            <a-span >{{appOptions[text]}}</a-span>
          </div>
        </template>

        <template slot='vendor' slot-scope='text'>
          <div class='slot-content'  :title='vendorOptions[text]'>
            <a-span >{{vendorOptions[text]}}</a-span>
          </div>
        </template>

        <template slot='content'  slot-scope='text'>
          <div class='slot-content' :title='text'>
            <a-span >{{text}}</a-span>
          </div>
        </template>

        <span  slot="productStock" slot-scope="text, record" >
          <a @click='handleDetail(record)'>{{text}}</a>
        </span>

        <span  slot="productDetail" slot-scope="text, record" >
          <a @click='productDetail(record)'>{{text}}</a>
        </span>


        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)" v-if='record.editAble' v-has="'gift:stock:edit'">{{language['common.edit']}}</a>

          <a-divider type="vertical" v-if='record.editAble' />

           <a @click="handleDetail(record)"  v-has="'gift:stock:detail'" >{{language['common.detailsButton']}}</a>

<!--          <a-dropdown>
            <a class="ant-dropdown-link">{{language['common.more']}} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item v-has="'gift:stock:detail'">
                <a @click="handleDetail(record)"  v-has="'gift:stock:detail'" >{{language['common.detailsButton']}}</a>
              </a-menu-item>
              <a-menu-item  v-has="'gift:stock:delete'">
                <a-popconfirm :title="language['common.deleteConfirmInfo']" @confirm="() => handleDelete(record.id)"  v-has="'gift:stock:delete'" >
                  <a>{{language['common.delete']}}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>-->
        </span>

      </a-table>
    </div>

    <product-stock-modal ref="modalForm" @ok="modalFormOk"></product-stock-modal>
  </a-card>
</template>

<script>

  import '@assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import ProductStockModal from './modules/ProductStockModal'
  import { getAction,downFile  } from '@api/manage'

  export default {
    name: 'ProductStockList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      ProductStockModal
    },
    data () {
      const language = this.$store.getters.language;
      return {
        disableMixinCreated: true,
        vendorMap:[],
        supplierCode:'',
        appCode :'',
        description: 'product stock',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:language['gift_product_code'],
            align:"center",
            width: 120,
            dataIndex: 'productCode',
            scopedSlots: { customRender: 'productDetail' },
          },
          {
            title:language['gift_product_name'],
            align:"center",
            width: 200,
            dataIndex: 'productName',
            scopedSlots: { customRender: 'content' },
          },
          {
            title:language['gift_product_total_stock'],
            align:"center",
            width: 100,
            dataIndex: 'allCount'
          },
          {
            title:language['gift_product_saled'],
            align:"center",
            width: 100,
            dataIndex: 'saleCount'
          },
          {
            title:language['gift_product_remaining_stock'],
            align:"center",
            width: 100,
            dataIndex: 'balance',
            scopedSlots: { customRender: 'productStock' },
          },
          {
            title:language['gift_product_price'],
            align:"center",
            width: 100,
            dataIndex: 'price'
          },
          {
            title:language['gift_product_business'],
            align:"center",
            dataIndex: 'supplierName',
            scopedSlots: { customRender: 'content' },
            width:200,
          },
          {
            title:language['gift_merchant_name'],
            align:"center",
            dataIndex: 'businessName',
            scopedSlots: { customRender: 'content' },
            width:200,
          },
          {
            title:language['gift_user_app'],
            align:"center",
            dataIndex: 'appName',
            scopedSlots: { customRender: 'content' },
            width:150,
          },
          {
            title: language['common.action'],
            dataIndex: 'action',
            align:"center",
            width:150,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/gift/stock/productstocks",
          delete: "/gift/stock/productstock",
          deleteBatch: "/gift/stock/productstock/batch",
          exportXlsUrl: "/gift/stock/export-xls",
          importExcelUrl: "gift/stock/import",
          getInitData: "/gift/stock/initData",
          vendorListByApp: '/gift/vendor/listByApp',
          checkAppLimit: '/gift/app/checkAppLimit/code',
          importTemplate: '/gift/stock/exportTemplate',
        },
        dictOptions:{},
        superFieldList:[],
        appOptions:[],
        vendorOptions:{},
        appLimit:{
          flag: false,
          value: undefined
        }
      }
    },
    created() {
        this.checkAppLimit();
        this.getInitData();
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      downloadTemplate(){
        let fileName = "商品庫存批量更新";
        let param = this.getQueryParams();
        if(this.selectedRowKeys && this.selectedRowKeys.length>0){
          param['selections'] = this.selectedRowKeys.join(",")
        }
        downFile(this.url.importTemplate,param).then((data)=>{
          if (!data) {
            this.$message.warning(this.language['common.fileDowloadError'])
            return
          }
          if (typeof window.navigator.msSaveBlob !== 'undefined') {
            window.navigator.msSaveBlob(new Blob([data],{type: 'application/vnd.ms-excel'}), fileName+'.xls')
          }else{
            let url = window.URL.createObjectURL(new Blob([data],{type: 'application/vnd.ms-excel'}))
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', fileName+'.xls')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link); //下载完成移除元素
            window.URL.revokeObjectURL(url); //释放掉blob对象
          }
        })
      },
      async checkAppLimit(){
         await getAction(this.url.checkAppLimit).then(res=>{
          if (res.success){
            this.appLimit.flag = true;
            this.appLimit.value = res.result;
            this.queryParam.appCode = res.result;
            this.handlerApp(res.result);
          }
        })
        this.loadData(1);
      },
      handlerApp(val) {
        this.getVendorList(val);
        this.queryParam.supplierCode = undefined;
      },
      updateSupplier(val) {
        this.queryParam.supplierCode = val;
        this.$forceUpdate();
      },
      getVendorList(val){
        getAction(this.url.vendorListByApp,{appCode:val}).then(res=>{
          if (res.success) {
          const newVendorMap = {};
          if (res.result && Array.isArray(res.result)) {
            res.result.forEach(item => {
              // 將回傳的陣列轉換為 { code: name } 格式的物件
              newVendorMap[item.code] = item.name;
            });
          }
          this.vendorMap = newVendorMap;
        }
        })
      },
      searchReset(){
         this.queryParam = {};
         if (this.appLimit.flag){
           this.queryParam.appCode = this.appLimit.value;
           this.handlerApp(this.appLimit.value);
         }else {
           this.vendorMap = [];
         }
         this.supplierCode = undefined;
         this.loadData(1);
      },
      changeSupplierCode(value, option){
        this.queryParam.supplierCode = option.key;
      },
      changeAppCode(value, option){
        this.queryParam.appCode = option.key;
      },
      initDictConfig(){
      },
      getInitData(){
         getAction(this.url.getInitData).then(res=>{
             if (res.success){
               this.appOptions = res.result.app;
               this.vendorOptions = res.result.vendor;
               this.$forceUpdate();
             }
         })
      },
      productDetail(record){
        this.$router.push({path:'/gift/productList', query:{id:record.productId}});
      },
      handleDetail(record){
        this.$refs.modalForm.detail(record);
        this.$refs.modalForm.title=this.language['common.detailsButton'];
        this.$refs.modalForm.disableSubmit = true;
      },

    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
  .slot-content{
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 200px;
  }
</style>
